import { env } from '@/env';
import { authClient } from '@/lib/api/authClient';
import { tokenStorage } from '@/lib/auth/tokenStorage';
import { useAuthStore } from '../store/authStore';

// Logout flow:
//   1. POST /auth/logout to auth service — revokes refresh token + clears sc_sso cookie
//   2. clearSession() — wipes local tokens + Zustand user state
//   3. window.location.assign(VITE_AUTH_FRONTEND_URL/login) — hard nav to auth login page
//
// Environment URLs:
//   Dev     → http://localhost:5004/login
//   Staging → https://uat-identity.signcare.io/login
//   Prod    → https://identity.signcare.io/login
export function useLogout() {
  const clearSession = useAuthStore((s) => s.clearSession);

  return async () => {
    const refreshToken = tokenStorage.getRefreshToken();

    // Best-effort: revoke server-side. Don't block UX on a network failure.
    try {
      await authClient.post('auth/logout', {
        json: { refreshToken: refreshToken ?? null },
      });
    } catch {
      // Ignore — token was invalid or network was down. Proceed with local clear.
    }

    clearSession();

    window.location.assign(`${env.VITE_AUTH_FRONTEND_URL}/login`);
  };
}
